import i18n from 'modules/core/lib/i18n'

export const translations = () => {
  return {
    payroll: {
      noExpenses: {
        title: i18n.t('finance.financial_workspace.launch_banner.payroll_bundle.title'),
        description: i18n.t(
          'finance.financial_workspace.launch_banner.payroll_bundle.descriptions.payroll.no_expenses'
        ),
      },
      expenses: {
        title: i18n.t('finance.financial_workspace.launch_banner.payroll_bundle.title'),
        description: i18n.t(
          'finance.financial_workspace.launch_banner.payroll_bundle.descriptions.payroll.expenses'
        ),
      },
    },
    noPayroll: {
      noExpenses: {
        title: i18n.t('finance.financial_workspace.launch_banner.payroll_bundle.title'),
        description: i18n.t(
          'finance.financial_workspace.launch_banner.payroll_bundle.descriptions.no_payroll.no_expenses'
        ),
      },
      expenses: {
        title: i18n.t('finance.financial_workspace.launch_banner.payroll_bundle.title'),
        description: i18n.t(
          'finance.financial_workspace.launch_banner.payroll_bundle.descriptions.no_payroll.expenses'
        ),
      },
    },
  }
}
